import { useEffect, useState } from "react"
import { useWeb3React } from "@web3-react/core";
import nftAbi from '../json/nftAbi.json';
import { contract } from "./constant";
import { getMultiCall } from "./useContracts";
import { getWeb3 } from "./connectors";
import { DEFAULT_CHAIN } from "./constant";
import { toast } from "react-toastify";


export const useCommonStats = (updater) => {
    let { chainId } = useWeb3React();
    let web3 = getWeb3(DEFAULT_CHAIN);


    const [stats, setStats] = useState({
        MAX_SUPPLY: 0,
        Max_Wallet: 0,
        cost: 0,
        paused: true,
        totalSupply: 0

    });

    let stakeContract = new web3.eth.Contract(nftAbi, contract[DEFAULT_CHAIN].NFT_ADDRESS);



    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    stakeContract.methods.maxSupply(), //0
                    stakeContract.methods.MaxTx(), //1
                    stakeContract.methods.cost(), //2
                    stakeContract.methods.paused(), //3
                    stakeContract.methods.totalSupply(), //4
                ]);

                setStats({
                    MAX_SUPPLY: data[0],
                    Max_Wallet: data[1],
                    cost: data[2] / Math.pow(10, 18),
                    paused: data[3],
                    totalSupply: data[4]
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }


        fetch();

        // eslint-disable-next-line
    }, [updater, chainId]);

    return stats;
}


export const useAccountStats = (updater) => {
    let { chainId, account } = useWeb3React();
    let web3 = getWeb3(DEFAULT_CHAIN);


    const [stats, setStats] = useState({
        refCount: 0,
        balanceOf: 0
    });


    let stakeContract = new web3.eth.Contract(nftAbi, contract[DEFAULT_CHAIN].NFT_ADDRESS);



    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    stakeContract.methods.refCount(account), //0
                    stakeContract.methods.balanceOf(account) //1
                ]);

                setStats({
                    refCount: data[0],
                    balanceOf: data[1]
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }

        if (account) {
            fetch();
        }
        else {
            setStats({
                refCount: 0,
                balanceOf: 0
            })
        }
        // eslint-disable-next-line
    }, [updater, chainId, account]);

    return stats;
}